export const testimonials = [
  {
    id: 1,
    name: "John",
    message:
      "No roof no problem, love it. Works for me as well because I am a renter...",
    location: "Sydney",
    rating: 5,
  },
  {
    id: 2,
    name: "Greg",
    message: "I had 6 panels and I just bought 20 more.",
    location: "ACT",
    rating: 5,
  },
  {
    id: 3,
    name: "Paul",
    message: "I am moving house again soon but SolarCloud goes wherever I go.",
    location: "Castle Hill",
    rating: 5,
  },
];
